import { useQueryClient } from '@tanstack/react-query';
import { pathgen } from 'object-path-generator';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { ServerError } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
export const useUnarchiveDraftTestIds = pathgen('useUnarchiveDraftTestIds');
export const useUnarchiveDraft = (param)=>{
    let { onSuccess, biCode } = param;
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutationState({
        mutationFn: async (draftId)=>{
            const { success, error } = await handleRequest(api.draft.unarchive(draftId));
            if (!success && !error.hasServerError(ServerError.DraftNotArchived)) {
                throw error;
            }
        },
        biCode,
        toasts: {
            successMessage: 'Draft unarchived successfully',
            successTestId: useUnarchiveDraftTestIds.SuccessToast(),
            errorMessage: 'Failed to unarchive draft',
            errorTestId: useUnarchiveDraftTestIds.ErrorToast()
        },
        onSuccess: (_result, draftId)=>{
            queryClient.setQueryData([
                QueryKeys.ArchivedProposals
            ], (archived)=>archived === null || archived === void 0 ? void 0 : archived.filter((draft)=>draft.id !== draftId));
            queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.ArchivedProposals
                ]
            });
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
    return {
        unarchiveDraft: mutate,
        isLoading
    };
};
